<button [ngStyle]="getButtonStyles()">{{ getButtonText() }}</button>
